import React from 'react';
import { useRouter } from 'next/router';
import { NextPageWithLayout } from 'next';
import Layout from '../components/Layout';
import withApollo from '../lib/apollo';
import { useSiteContext } from '../components/SiteContext';
import Heading from '../components/Products/Heading';
import DynamicProducts from '../components/Products/DynamicProducts';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';

const ProductsPage = () => {
  const { locale } = useSiteContext();
  const router = useRouter();
  const { query } = router;

  const { marketId, standId } = query;

  const variables = {
    marketId: marketId ? Number(marketId) : undefined,
    standId: standId ? Number(standId) : undefined,
    locales: [locale],
  };

  return (
    <>
      <Heading {...variables} />
      <DynamicProducts />
    </>
  );
};

ProductsPage.getLayout = (page : NextPageWithLayout) => (
  <Layout
    overflow="visible"
    layoutMaxWidth="none"
    layoutMarginBottom="0"
  >
    {page}
  </Layout>
);

ProductsPage.getInitialProps = redirectRouteToDomain(
  'products',
);

export default withApollo(ProductsPage);
